import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';
import { ESTADO_CREADO_CODE } from './data/custodiaDicctionary';
import { ConfiguracionService } from '../../services/Configuracion/ConfiguracionService';
import { ValidarEstatusButton } from './ValidarEstatusButton';
const TIPO_SENUELO_CUSTODIADO = '3';
const TIPO_SENUELO_COMPONENTE = '4';

export const Senuelos = ({ senuelosEdit, onClose, onSuccesSave, estadoCustodia, openEvidenciaGeneral, tablaOrigen, onlyRead }) => {
    const [senuelosLocal, setSenuelosLocal] = useState([]);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [senueloSelected, setSenueloSelected] = useState(null);
    const [senuelosOptions, setSenuelosOptions] = useState([]);

    const toast = useRef(null);

    useEffect(() => {
        setSenuelosLocal(senuelosEdit || []);
        setIsDialogOpen(senuelosEdit !== null && senuelosEdit !== undefined);

        return () => {
            setIsDialogOpen(false);
            setSenuelosLocal([]);
            setSenueloSelected(null);
        };
    }, [senuelosEdit]);

    useEffect(() => {
        loadSenuelosOptions();
    }, []);

    const configuracionService = new ConfiguracionService();
    const loadSenuelosOptions = async () => {
        // Aquí podrías cargar las opciones de señuelos desde una API o fuente de datos
        try {
            const response = await configuracionService.getListaSenuelos();
            setSenuelosOptions(
                response.map((item) => ({
                    id: item.dispositivoId,
                    nombre: item.nombre
                }))
            );
        } catch (error) {
            console.error('Error al cargar las opciones de señuelos:', error);
        }
    };

    const handleAgregarSenuelo = () => {
        if (!senueloSelected) return;

        // si ya se encuentra en la lista, mostrar un mensaje de error
        if (senuelosLocal.find((s) => s.dispositivoId === senueloSelected.id)) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'El señuelo ya está en la lista', life: 3000 });
            return;
        }

        // Nota: "Validar estatus" es solo informativo; NO bloquea el agregado.
        setSenuelosLocal([...senuelosLocal, { id: 'temp-' + Date.now(), dispositivoId: senueloSelected.id }]);
        setSenueloSelected(null);
    };

    const footerTemplate = (
        <div>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-secondary" onClick={onClose} />
            <Button label="Guardar" icon="pi pi-check" className="p-button-success" onClick={() => onSuccesSave(senuelosLocal)} disabled={estadoCustodia !== ESTADO_CREADO_CODE || onlyRead} />
        </div>
    );

    const actionsBodyTemplate = (rowData) => {
        return (
            <div>
                <Button
                    icon="pi pi-trash"
                    className="p-button-danger p-button-rounded"
                    tooltip="Eliminar"
                    onClick={() => {
                        setSenuelosLocal(senuelosLocal.filter((s) => s.id !== rowData.id));
                    }}
                    disabled={estadoCustodia !== ESTADO_CREADO_CODE || onlyRead}
                />
                <Button
                    icon="pi pi-image"
                    className="p-button-rounded p-button-text ml-2"
                    tooltip="Cargar Evidencia"
                    onClick={() => openEvidenciaGeneral(tablaOrigen === 'custodiado' ? TIPO_SENUELO_CUSTODIADO : TIPO_SENUELO_COMPONENTE, rowData.id)}
                    disabled={typeof rowData.id === 'string' && rowData.id.startsWith('temp-') || onlyRead}
                />
                <ValidarEstatusButton dispositivoId={rowData.dispositivoId} mini />
            </div>
        );
    };

    return (
        <Dialog visible={isDialogOpen} closable={false} header="Gestión de Señuelos" modal className="p-fluid w-full md:w-9 lg:w-6" onHide={onClose} footer={footerTemplate}>
            <Toast ref={toast} position="top-center" />
            <div className="grid flex flex-column md:flex-row lg:flex-row sm:flex-row">
                <div className="field col">
                    <label htmlFor="clienteList">Señuelo </label>
                    <div className="p-inputgroup">
                        <Dropdown
                            id="senueloSelect"
                            filter
                            value={senueloSelected}
                            options={senuelosOptions}
                            onChange={(e) => setSenueloSelected(e.value)}
                            optionLabel="nombre"
                            placeholder="Seleccione un señuelo"
                            disabled={estadoCustodia !== ESTADO_CREADO_CODE || onlyRead}
                        />
                    </div>
                </div>
                <div className="field col-12 md:col-4 flex align-items-end gap-2">
                    <Button icon="pi pi-arrow-down" className="p-button-success" tooltip="Agregar" onClick={handleAgregarSenuelo} disabled={estadoCustodia !== ESTADO_CREADO_CODE || onlyRead} />
                    <ValidarEstatusButton dispositivoId={senueloSelected?.id} />
                </div>
            </div>
            <div className="col-12">
                <h5>Señuelos Asignados</h5>
                <DataTable value={senuelosLocal} dataKey="id" responsiveLayout="scroll">
                    <Column field="dispositivoId" header="ID Dispositivo" />
                    <Column header="Nombre Señuelo" body={(rowData) => senuelosOptions.find((s) => s.id === rowData.dispositivoId)?.nombre} />
                    <Column header="Acciones" body={actionsBodyTemplate} />
                </DataTable>
            </div>
        </Dialog>
    );
};
